export default function(app) {
  const components = require.context('.', true, /[A-Za-z0-9-_,\s]+\.vue$/i)

  components.keys().forEach(fileName => {
    const component = components(fileName).default
    app.component(component.name, component)
  })
}